import { SkeletonSquareGrid } from "#common/Skeleton"
import { useApi } from "#hooks/useApi"
import { TarjetaPdfProvider } from "#training/contexts/contextsTarjeta"
import { UseReduxTraining } from "#training/redux/slice"
import { courseCollaboratorGet } from "#training/services/Api"
import { Box, Stack } from "@mui/material"
import Typography from "@mui/material/Typography"
import { actualizarNotify } from "app/notificationSlice"
import { ESTADO_CURSOS } from "Components/Capacitaciones/constants_capacitaciones"
import { ChangeTitle } from "Components/menu/funciones"
import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AccordionCategory, ViewPdfTarjeta } from "./Colaborador"

//Componente --------------------------------------------->
export default function PorAprobar() {
	ChangeTitle("Curso Por Aprobar")
	const { reload } = UseReduxTraining()
	const params = useMemo(() => ({ status: ESTADO_CURSOS["REVISAR"] }), [])
	const { data, loading } = useApi(courseCollaboratorGet, {
		params,
		autoFetch: true,
		reload,
	})

	const token = useSelector((state) => state.user.token)
	const [actualizarPorAprobar] = useState([]) //permite cambiar el estado de la tarjeta
	const dispatch = useDispatch()
	useEffect(() => {
		//-------------------------------------------------------------------------------------------------------------------------------------
		dispatch(actualizarNotify(token))
	}, [dispatch, token, actualizarPorAprobar])
	const categories = useMemo(() => {
		return [...new Set(data?.cursos.map((curso) => curso.category))]
	}, [data?.cursos])

	const accordion = useMemo(() => {
		return categories.map((category) => {
			const cursos_category = data?.cursos.filter((curso) => curso.category === category)
			return (
				<AccordionCategory
					data={{ category, count: cursos_category.length, data: cursos_category }}
				/>
			)
		})
	}, [categories, data?.cursos])

	if (loading)
		return (
			<SkeletonSquareGrid
				propsG={{
					xs: 12,
					md: 6,
					xl: 4,
				}}
				quantity={12}
			/>
		)
	if (!data?.count)
		return (
			<Typography
				xs={12}
				sx={{
					mb: 1.5,
					fontWeight: "bold",
					textAlign: "center",
					fontSize: 40,
				}}
			>
				No Hay Curso Por Aprobar
			</Typography>
		)

	return (
		<Box>
			<Stack spacing={2}>
				<TarjetaPdfProvider>
					{accordion}

					<ViewPdfTarjeta />
				</TarjetaPdfProvider>
			</Stack>
		</Box>
	)
}
